import React, { useEffect, useState } from "react";

import { connect } from "react-redux";
import moment from "moment";
import { withTranslation } from "react-i18next";
import { sendAnalytics } from "../../../action/homeAction";
import { popupOpenClose, setRegPage } from "../../../action/action";
import { closeOrderPopUp } from "../../action/hCommerce2";
import { setGoHome, setLoginRequired } from "../../action/homeAction";
import { CLICKED, CMSPath, EXIT } from "../../../config/constant";
import { getDefaultAnalyticsLabel } from "../../JS/utility";
import SuccessFailScreen from "../../UI/SuccessFailScreen";
import { formatLocalTime, formatTime, toBool } from "../../JS/utility";
import { dateFormatHandler } from "../../../JS/dateFormatHandler";
import MiniLoader from "../../UI/MiniLoader";
import { scrollToTop } from "../../../JS/scrollToTop";
import Gha_WelcomePage from "./Gha_WelcomePage";
import Gha_NewJoin from "./Gha_NewJoin";
import { loginGhaUser } from "../../../action/gha";
import Gha_ResetPassword from "./Gha_ResetPassword";






const Gha_Login = (props) => {

    const [shouldResetPassword, setShouldResetPassword]=useState(false);
    const [loginFormData, setLoginFormData]=useState({})
    const [showLoader, setShowLoader]=useState(false);

  

    
    const { t } = props;

    let widgetSesstionId = localStorage.getItem("ghaSessionToken");
    let label = getDefaultAnalyticsLabel({
        appVersion: props.installedAppVersion
            ? `${props.installedAppVersion}(${props.installedAppBuildNo})`
            : "",
    });

    const sendAnalytic=(isSuccess, res)=>{
        props.sendAnalytics(
            props.guestDetail,
            props.currentWidgets.widgetType,
            `Login response ${isSuccess?'Success':"failed"}`,
            {
                ...label,
                layoutTab: props.currentHomePage.tabName,
                element: "widget",
                widgetSessionId: widgetSesstionId,
                errorStatus: JSON.stringify(res),
                errorMessage: JSON.stringify(
                    res  
                ),
            },
            0,
            props.guestIsLoggedIn
        );
    }
     

    const loginUser = (formData)=>{
        setShowLoader(true);

        loginGhaUser(formData)
        .then((res)=>{
            console.log(res)
            console.log("accepted")
            if(res.response && res.response.status==409){
                if (res.response && res.response.data && res.response.data.payload && res.response.data.payload.profiles){
                    console.log("going to handle response positively")
                    props.handleNext(false, res.response.data.payload.profiles)
                }else{
                     
                    sendAnalytic(false,res.response)
                    throw new Error('')
                }
            }else if(res.status==200){
                if (res.data && res.data.statusMsg == "success" && res.data.payload && res.data.payload.profiles && res.data.payload.profiles.length==1){
                    props.handleNext(false, res.data.payload.profiles )
                }else{
                     
                    sendAnalytic(false, res)
                    throw new Error('')
                }
            }else{
                throw new Error(res.response && res.response.data && res.response.data.payload && res.response.data.payload.errorMsg ||'')

            }
        
        })
        .catch((err)=>{
            console.log(err)
            console.log("in catch")
          
            props.closeOrderPopUp(true, (err ) || t('gha.errors.something_went_wrong'), "", true)
        })
        .finally(()=>{
            setShowLoader(false);
        })
    }

    const handleChangeValue=(data) =>{
        const formData= JSON.parse(JSON.stringify(loginFormData));
        setLoginFormData({...formData, ...data});
    }


    const handleClickSubmit=()=>{
        if (!loginFormData.hasOwnProperty("username") || loginFormData.username=="" ){
            props.popupOpenClose("true", `${t("gha.enter_username")}`);
            return;
        }
        if (!loginFormData.hasOwnProperty("password") || loginFormData.password == "") {
            props.popupOpenClose("true", `${t("gha.enter_password")}`);
            return;
        }

        const formData= JSON.parse(JSON.stringify(loginFormData));
        loginUser(formData);
        


    } 

    const handleGoBack=()=>{
        if (shouldResetPassword){
            setShowLoader(false);
            setLoginFormData({})
            setShouldResetPassword(false);
        }
        else{
            props.handleGoBack();
        }
    }

    
    useEffect(() => {

        scrollToTop();


    }, []);




    return (

        <>
            {
                !shouldResetPassword
                    ?
                    <>
                    
                        <header class="inner-pages w-footer subpages">
                            <a class="button-back" onClick={handleGoBack}></a>
                            <div class="heading align-center">
                                <div class="splash-brand">
                                    <img src={`${CMSPath}${props.logo}`} />
                                </div>
                            </div>
                        </header>
                    <section class="widgets">
                        <div class="widget-header">
                            <div class="widget-header-img">
                                <img src= {require ("./assests/login.png")}    />
                            </div>
                                <div class="widget-header-title"><strong>{t("gha.log_in")}</strong> {t("gha.to_viceroy_discovery_loyalty")}</div>
                        </div>
                        <div id="GHALogin" class="widgets sign-up">
                            <div class="row sign-up-form">
                                    <h4>{t("gha.login_form_heading")}</h4>
                                <div class="form-row">
                                        <label>{t("gha.email_address")} </label>
                                        <input type="text" placeholder="Enter Email " autoComplete='email' value={loginFormData.username || ''} onChange={(e) => { handleChangeValue({ username : e.target.value})}}/>
                                </div>
                                <div class="form-row">
                                        <label>{t("gha.password")}</label>
                                        <input type="password" placeholder="Enter your password" value={loginFormData.password || ''} onChange={(e) => { handleChangeValue({ password: e.target.value }) }}/>
                                </div>
                                {/* <div class="form-row checkbox">
                                    <input type="checkbox" name="remember user">
                                        <label>Remember me</label>
                                </div> */}
                                <div class="form-controls">
                                   

                                     {showLoader ? <button disabled class="primary w-100 margin-bottom-1"><div class="loader-ring"><img src="layout_2/assests/loader.png" /></div> {t('gha.logging_in')}</button> :
                                            <button class="primary w-100 margin-bottom-1" onClick={handleClickSubmit}>{t("gha.login_button")}</button>                        }

                                        <button class="secondary w-100" onClick={() => setShouldResetPassword(true)}>{t("gha.reset_password")}</button>
                                </div>
                            </div>
                        </div>
                    </section>
                    </>
                    :
                    <Gha_ResetPassword handleGoBack={handleGoBack}/>

            }
            
        

        </>
    );
};

const mapStateToProps = (state) => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
        dateFormat: state.store.home.clientConfig.extraConfigParam
            ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT
            : "",
        timeFormat: state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM,
        logo: state.store.home.currentDuration.brandingInfo
            ? state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl
            : "",
    };
};

export default connect(mapStateToProps, { popupOpenClose, closeOrderPopUp, sendAnalytics })(
    withTranslation("translations")(Gha_Login)
);
